//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, withStyles } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
}));
const styles = theme => ({
    previewBody: {
        background: '#FFFFFF',
        border: '1px dashed #D5D7DD',
        borderRadius: '10px',
        width: '270px',
        height: '180px',
        marginTop: '32px',
        textAlign: 'center',
    },
    previewBodyBg: {
        background: '#F1F8F8',
        border: '1px dashed #1D8A8B',
        borderRadius: '8px',
        width: '254px',
        height: '68px',
        margin: 'auto',
        marginTop: '8px',
    },
    previewProfilePic: {
        background: '#F0F2F6',
        border: '2px dashed #FFFFFF',
        borderRadius: '8px',
        width: '32px',
        height: '32px',
        margin: 'auto',
        textAlign: 'center',
    },
    dpBody: {
        position: 'relative',
        top: '-18px',
    },
    plusIconOutlined: {
        marginTop: '18px',
        color: '#1D8A8B',
    },
    skeltonLine: {
        width: '124px',
        height: '6px',
        borderRadius: '8px',
        background: '#F0F2F6',
        margin: 'auto',
        marginTop: '10px',
    },
    skeltonOval: {
        width: '40px',
        height: '16px',
        borderRadius: '8px',
        background: '#F0F2F6',
        display: 'inline-block',
        marginTop: '8px',
        marginRight: '2px',
        marginLeft: '2px',
    },
    previewBodyBanner: {
        borderRadius: '8px',
        width: '254px',
        height: '68px',
        marginTop: '8px',
    },
});

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { props } = params;
    const { classes } = props;
    const defns = {};

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const BrandingBannerPreview = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    if (props.isHidden) return null;
    const { bannerUrl } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.previewBody}>
                {bannerUrl === '' ? (
                    <div {...defns.previewBodyBg}>
                        <AddCircleIcon {...defns.plusIconOutlined} />
                    </div>
                ) : (
                    <div>
                        <img src={bannerUrl} alt="" {...defns.previewBodyBanner} />
                    </div>
                )}

                <div {...defns.dpBody}>
                    <div {...defns.previewProfilePic}></div>
                    <div {...defns.skeltonLine}></div>
                    <div {...defns.skeltonOval}></div>
                    <div {...defns.skeltonOval}></div>
                </div>
            </div>
        </div>
    );
};

export default withStyles(styles)(BrandingBannerPreview);
